import { Box, SideSheet } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const OrderConfirmationContainerStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
  flexDirection: { sm: 'column' },
  gap: { sm: '700' },
})`
  height: 100%;
`;

export const OrderConfirmationSideSheetStyled = styled(SideSheet)`
  width: calc(100vw - ${({ theme }) => theme.componentStyles.navBarWidth});
`;

export const OrderConfirmationStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border-radius: ${theme.radii[500]};
    border: 1px solid ${theme.colors.grey[300]};
    min-width: 50%;
    max-height: 600px;
  `}
`;

export const OrderConfirmationHeaderStyled = styled.div`
  ${({ theme }) => css`
    width: 100%;
    background-color: ${theme.colors.green[100]};
    padding-top: ${theme.spacings[500]};
    padding-left: ${theme.spacings[800]};
    padding-right: ${theme.spacings[800]};
    padding-bottom: ${theme.spacings[500]};
    text-align: center;
    line-height: ${theme.spacings[600]};
    border-start-end-radius: ${theme.radii[500]};
    border-top-left-radius: ${theme.radii[500]};
  `}
`;

export const OrderConfirmationBodyHeaderStyled = styled.div`
  ${({ theme }) => css`
    border-top: 1px solid ${theme.colors.grey[300]};
    width: 100%;
  `}
`;

export const OrderConfirmationBodyStyled = styled.div`
  ${({ theme }) => css`
    border-top: 1px solid ${theme.colors.grey[300]};
    padding-top: ${theme.spacings[500]};
    width: 100%;
    overflow-y: auto;
  `}
`;

export const ItemCountStyled = styled.div`
  ${({ theme }) => css`
    height: 30px;
    padding-left: ${theme.spacings[600]};
    padding-top: ${theme.spacings[300]};
    padding-right: ${theme.spacings[600]};
    padding-bottom: ${theme.spacings[300]};
    border-radius: ${theme.radii[700]};
    border: 1px solid ${theme.colors.blue[800]};
  `}
`;
